module.exports = __webpack_public_path__ + "static/media/twitter.3371d517.svg";